
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.806 1.55a.5.5 0 01.438 0l1.847.9c1.435.7 3.01 1.07 4.608 1.084l1.305.011a.5.5 0 01.496.5v8.136c0 4.838-3.313 9.051-8.03 10.224l-.325.08a.5.5 0 01-.24 0l-.36-.089C6.82 21.23 3.5 17.012 3.5 12.17V4.013a.5.5 0 01.5-.5h1.292c1.62 0 3.22-.366 4.676-1.072l1.838-.891zm.218 1.006l-1.62.785a11.726 11.726 0 01-5.112 1.172H4.5v7.656c0 4.38 3.002 8.199 7.284 9.256l.24.06.205-.05c4.275-1.063 7.271-4.88 7.271-9.254v-7.64l-.81-.007a11.725 11.725 0 01-5.037-1.184l-1.63-.794zm3.288 6.054a.5.5 0 01.078.702l-4 5a.5.5 0 01-.755.03l-2-2.144a.5.5 0 11.73-.682l1.606 1.72 3.639-4.548a.5.5 0 01.702-.078z","fill":"#BB85FF"}})])
          )
        }
      }
    